// ======================================================================
// File Name       : userfrontImage
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const USERFRONT_INITIAL_IMAGE_LIST = 'USERFRONT_INITIAL_IMAGE_LIST';
export const USERFRONT_INITIAL_TOP_IMAGE_LIST = 'USERFRONT_INITIAL_TOP_IMAGE_LIST';
export const USERFRONT_CHANGE_IMAGE_FILE = 'USERFRONT_CHANGE_IMAGE_FILE';
export const USERFRONT_CHANGE_IMAGE_DATA = 'USERFRONT_CHANGE_IMAGE_DATA';
export const USERFRONT_GET_IMAGE_DATA = 'USERFRONT_GET_IMAGE_DATA';
export const USERFRONT_RESET_INIT_STATE = 'USERFRONT_RESET_INIT_STATE';
